import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import { useParams, Link } from "react-router-dom";
import Styled from "styled-components";
import Button from "@material-ui/core/Button";
import SaveIcon from "@material-ui/icons/Save";
import Typography from "@material-ui/core/Typography";
import { Add, Remove } from "@material-ui/icons";
import { DatePicker } from "@material-ui/pickers";
import { Select, MenuItem, InputLabel, FormControl } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";

import { Wrapper } from "../../components/Control/Flexbox";
import { CenteredLogoImg } from "../../golbalStyles/global.styled";
import { images, textInputs } from "../../constants/constants";
import SelectPart from "./SelectPart";
import Modal from "../../components/Control/Modal";
import { CloseButton } from "../../GlobalUtils/ButtonsGlobal";
import useConfirm from "../../components/Control/useConfirm";
import { ButtonStyled, TableContainerStyled } from "../DailyProduction/styles";
import TableReadEditCell from "../../components/TableEditCell";
import { useQuery } from "../../components/Control/useQuery";
import { mdiFileExcel } from "@mdi/js";
import Icon from "@mdi/react";
import Tooltip from "@material-ui/core/Tooltip";
import TableToExcel from "@dayalk/table-to-excel";
import formatDate from "../../components/Control/formatDate";
const Table = Styled.table`
	margin-bottom: 1rem;
    th{
        font-size: 12px;
		    font-family:"Roboto",sans-serif;
        border: 1px solid black;
        padding: 0.4rem;
        p{
          margin:0;
        }
    }

    td{
        font-size: 12px;
        border: 1px solid black;
        padding: 0.3rem;
        p{
          margin:0;
        }
    }
    span{
      font-weight:500;
    }

    .input {
        outline: none;
        width: 200px;
        border: none;
        height: 50px;
        text-align:center;
    }

`;

const ControlledInput = ({ onUpdate, disable, defaultvalue }) => {
  const [value, setState] = useState(defaultvalue);

  useEffect(() => {
    if (disable) {
      setState("");
    }
  }, [disable]);

  const handleChange = (e) => {
    setState(e.target.value);
    onUpdate(e.target.value);
  };

  return (
    <input
      className="input"
      value={value}
      disabled={disable}
      onChange={handleChange}
    />
  );
};

const dropdownStyles = makeStyles({
  root: {
    backgroundColor: "#fff",
  },
  select: {
    "&:hover": {
      backgroundColor: "#fff",
    },
    "&:focus": {
      backgroundColor: "#fff",
    },
  },
  underline: {
    borderBottom: "0px solid red !important",
    "&:hover": {
      borderBottom: "0px solid rgba(0,0,0,0)",
    },
  },
});

const ScrapAddEdit = () => {
  const classes = dropdownStyles();
  const { id } = useParams();
  const [isSelectPartModal, selectSelectPartModal] = useState(false);
  const [render, setRender] = useState(false);
  const [partDetails, setPartDetails] = useState([]);
  const indexSelectPart = useRef(0);
  const history = useHistory();
  const query = useQuery();
  const [failures, setFailures] = useState(new Array(25).fill().map((_) => []));
  const [scrapNoteData, setScrapNoteData] = useState({
    dailyProduction_date: new Date(),
    processes: new Array(25).fill().map((_) => ({})),
  });

  const isView = query.get("isView") === "true" ? true : false;

  const [DialogClose, confirmClose] = useConfirm(
    "CLOSE",
    "Are you sure you want to leave this page?"
  );
  const [DialogSave, confirmSave] = useConfirm(
    "SAVE",
    "Are you sure you want to save?"
  );
  const [DialogUpdate, confirmUpdate] = useConfirm(
    "SAVE",
    "Are you sure you want to Submit?"
  );

  useEffect(() => {
    axios
      .get(`/api/getPartDetails`)
      .then((res) => {
        setPartDetails(res.data?.results);
      })
      .catch((err) => console.log(err));
  }, []);

  const handleChangeInput = (e, index) => {
    const name = e.target.name;
    const value = e.target.value;
    if (index === 0 || index) {
      const values = { ...scrapNoteData };
      values.processes[index][name] = value;
      setScrapNoteData(values);
    }
  };
  const handleFailures = async (partId, index) => {
    axios
      .get(`/api/getFailuresByPart/${partId}`)
      .then((res) => {
        if (res.data) {
          failures[index] = res.data;
          setRender((prev) => !prev);
        }
      })
      .catch((err) => {
        console.log(err);
        setRender((prev) => !prev);
      });
  };

  useEffect(() => {
    if (!id) return;
    if (partDetails.length) {
      axios
        .get(`/api/getScrapNoteById/${id}`)
        .then((res) => {
          res.data.processes.map((item, index) => {
            if (item.part_id) {
              handleFailures(item.part_id._id, index);
            }
          });
          setScrapNoteData(res.data);
        })
        .catch((err) => console.log(err));
    }
  }, [partDetails]);

  const selectFailure = (e, index) => {
    const value = e.target.value;
    scrapNoteData.processes[index].reason = value;
  };

  const handlePartDetails = (partId, value, index) => {
    scrapNoteData.processes[indexSelectPart.current].part_id = partId;
    scrapNoteData.processes[indexSelectPart.current].part_number = value;
    const getPartNo = partDetails.filter((part) => part._id === partId);

    scrapNoteData.processes[indexSelectPart.current].part_name =
      getPartNo[0].part_name;
    handleFailures(getPartNo[0]._id, indexSelectPart.current);
  };

  const resetPartDetails = () => {
    scrapNoteData.processes[indexSelectPart.current].part_id = null;
    scrapNoteData.processes[indexSelectPart.current].part_number = null;
    scrapNoteData.processes[indexSelectPart.current].part_name = null;
    failures[indexSelectPart.current] = [];
    setRender((prev) => !prev);
  };

  const handleSubmitAndSave = async (bool) => {
    if (id) {
      let ans = await confirmUpdate();
      if (ans) {
        scrapNoteData.isSubmitted = bool;
        axios
          .put(`/api/updateScrapNoteById/${id}`, scrapNoteData)
          .then((res) => {
            if (res.data.status === "success") {
              alert("updated successfully");
            }
          })
          .catch((err) => console.log(err));
      }
    } else {
      let ans = await confirmSave();
      if (ans) {
        scrapNoteData.isSubmitted = bool;
        axios
          .post(`/api/createScrapNote`, scrapNoteData)
          .then((res) => {
            if (res.data.status === "success") {
              alert("created successfully");
              history.push("/scrapNoteList");
            }
          })
          .catch((err) => console.log(err));
      }
    }
  };

  const handleScroll = (scrolltype) => {
    if (scrolltype === "right") {
      document.getElementById("scroll").scrollLeft += 80;
    } else {
      document.getElementById("scroll").scrollLeft -= 80;
    }
  };

  return (
    <section>
      <div
        style={{
          paddingBottom: "4rem",
        }}
      >
        <ButtonStyled
          left
          onClick={(e) => {
            handleScroll("left");
          }}
        >
          <div>
            <ArrowBackIosIcon style={{ color: "#fff" }} />
          </div>
        </ButtonStyled>
        <ButtonStyled
          right
          onClick={(e) => {
            handleScroll("right");
          }}
        >
          <div>
            <ArrowForwardIosIcon style={{ color: "#fff" }} />
          </div>
        </ButtonStyled>

        <div className="divflex">
          <Typography
            style={{
              fontSize: "24px",
              fontFamily: "Nunito",
            }}
          >
            SCRAP NOTE REPORT
          </Typography>
          {!isView ? (
            <div style={{ display: "flex" }}>
              <Wrapper
                style={{
                  gap: "1rem",
                }}
              >
                <Button
                  type="button"
                  variant="contained"
                  color="primary"
                  size="large"
                  style={{
                    backgroundColor: "#003566",
                    marginRight: "0.5rem",
                  }}
                  startIcon={<SaveIcon />}
                  onClick={() => {
                    handleSubmitAndSave(false);
                  }}
                >
                  Save & Continue
                </Button>
                <Button
                  type="button"
                  variant="contained"
                  color="primary"
                  size="large"
                  style={{
                    backgroundColor: "#064a29",
                    marginRight: "0.5rem",
                  }}
                  startIcon={<CloudUploadIcon />}
                  onClick={() => {
                    handleSubmitAndSave(true);
                  }}
                >
                  Submit
                </Button>
                <CloseButton
                  onClick={async () => {
                    let ans = await confirmClose();
                    if (ans) {
                      history.goBack();
                    }
                  }}
                />
              </Wrapper>
            </div>
          ) : (
            <Tooltip arrow title="Export as spreadsheet">
              <div>
                <Button
                  style={{
                    backgroundColor: "#161a1d",
                    borderColor: "#161a1d",
                    color: "white",
                    width: "fit-content",
                    borderRadius: "0",
                    paddingTop: "9px",
                  }}
                  onClick={() => {
                    TableToExcel.convert(
                      document.getElementById("machinetable"),
                      {
                        name: "Scrape Note Report.xlsx",
                        sheet: {
                          name: "Scrape Note Report",
                        },
                      }
                    );
                  }}
                >
                  <Icon path={mdiFileExcel} size={1.2} />
                </Button>
              </div>
            </Tooltip>
          )}
        </div>
        <TableContainerStyled id="scroll">
          <Table
            cellSpacing="0"
            style={{ marginTop: "0.6rem", backgroundColor: "white" }}
            data-default-wrap="true"
            id="machinetable"
            data-cols-width="15, 15, 15, 20, 15, 18, 15, 15, 15, 15, 15, 15"
          >
            <thead>
              <tr style={{ height: "70px" }}>
                <th
                  colSpan="10"
                  align="left"
                  style={{
                    border: "1px solid black",
                    fontSize: "1.6rem",
                    textAlign: "center",
                    position: "relative",
                  }}
                >
                  <CenteredLogoImg>
                    <img
                      src={images.arcLogo}
                      alt={textInputs.companyName}
                      height="46"
                      width="120"
                    />
                    <span>{textInputs.companyName}</span>
                  </CenteredLogoImg>
                </th>
                <th
                  colSpan={2}
                  style={{
                    border: "1px solid black",
                  }}
                >
                  DOC. NO:- ARC/F/QAD/101
                </th>
              </tr>

              <tr>
                <th
                  colSpan="10"
                  align="center"
                  style={{
                    fontSize: "1.2rem",
                    fontWeight: 600,
                    backgroundColor: "#1d1d1d",
                    color: "white",
                    border: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  SCRAP NOTE REPORT
                </th>
                <th colSpan={2} style={{ border: "1px solid black" }}>
                  REV NO./DATE :- 01/29.09.2022
                </th>
              </tr>
              <tr>
                <th colSpan={12} style={{ border: "1px solid black" }}>
                  <Wrapper style={{ gap: "5px" }}>
                    DATE:
                    {isView ? (
                      formatDate(scrapNoteData.scrapnote_date)
                    ) : (
                      <DatePicker
                        name="date_performance"
                        format="dd/MM/yyyy"
                        InputProps={{
                          disableUnderline: true,
                        }}
                        style={{
                          backgroundColor: "#f8f9fa",
                        }}
                        value={scrapNoteData.scrapnote_date}
                        onChange={(date) => {
                          scrapNoteData.scrapnote_date = date;
                          setRender((prev) => !prev);
                        }}
                      />
                    )}
                  </Wrapper>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                {[
                  "SNO.",
                  "PART NO.",
                  "PART NAME",
                  "SUPPLIER & INHOUSE DEPT NAME",
                  "QTY",
                  "DESCRIPTION OF NON CONFORMITY",
                  "REASON OF REJECTION( PRODUCTION STATEMENT)",
                  "DEBIT NOTE NO.",
                  "RATE / PCS",
                  "AMOUNT",
                  "TOTAL WEIGHT",
                  "REMARKS",
                ].map((heading, index) => (
                  <th
                    key={index}
                    style={{
                      border: "1px solid black",
                      textAlign: "center",
                      textTransform: "uppercase",
                    }}
                  >
                    {heading}
                  </th>
                ))}
              </tr>

              {scrapNoteData.processes.map((item, index) => (
                <tr key={item._id || index}>
                  <th
                    style={{
                      width: "100px",
                      border: "1px solid black",
                      textAlign: "center",
                      padding: "0 0.4rem",
                      backgroundColor: "#f8f9fa",
                    }}
                  >
                    {index + 1}
                  </th>
                  <th
                    style={{
                      width: "100px",
                      border: "1px solid black",
                      textAlign: "center",
                      padding: "0 0.4rem",
                      backgroundColor: "#f8f9fa",
                    }}
                  >
                    {isView ? (
                      item?.part_number || item?.part_id?.part_number
                    ) : (
                      <Wrapper
                        justify="space-between"
                        style={{ width: "200px", backgroundColor: "#f8f9fa" }}
                      >
                        <p
                          style={{
                            fontSize: "0.8rem",
                          }}
                        >
                          {item?.part_id?.part_number ||
                            item?.part_number ||
                            "Pick Part No."}
                        </p>
                        {item?.part_number || item?.part_id?.part_number ? (
                          <Wrapper
                            className="pir_add_modal"
                            style={{ backgroundColor: "#003566" }}
                            justify="center"
                            onClick={() => {
                              item.part_number = null;
                              item.part_id = null;
                              item.part_name = null;
                              failures[index] = [];
                              setRender((prev) => !prev);
                            }}
                          >
                            <Remove />
                          </Wrapper>
                        ) : (
                          <Wrapper
                            className="pir_add_modal"
                            justify="center"
                            style={{ backgroundColor: "#495057" }}
                            onClick={() => {
                              indexSelectPart.current = index;
                              selectSelectPartModal(true);
                            }}
                          >
                            <Add />
                          </Wrapper>
                        )}
                      </Wrapper>
                    )}
                  </th>
                  <td
                    style={{
                      minWidth: "180px",
                      border: "1px solid black",
                      textAlign: "center",
                    }}
                  >
                    <div style={{ maxHeight: "50px", overflow: "auto" }}>
                      {item?.part_name || item?.part_id?.part_name}
                    </div>
                  </td>
                  <td
                    align="center"
                    style={{
                      border: "1px solid black",
                    }}
                  >
                    <TableReadEditCell
                      {...{ index }}
                      isView={isView}
                      type="text"
                      value={item.supplier_dept_name}
                      name="supplier_dept_name"
                      handleChange={(e, index) => handleChangeInput(e, index)}
                    />
                  </td>
                  <td
                    align="center"
                    style={{
                      border: "1px solid black",
                    }}
                  >
                    <TableReadEditCell
                      {...{ index }}
                      isView={isView}
                      type="number"
                      name="qty"
                      value={item.qty}
                      handleChange={(e, index) => handleChangeInput(e, index)}
                    />
                  </td>
                  <td
                    align="center"
                    style={{
                      border: "1px solid black",
                    }}
                  >
                    <TableReadEditCell
                      {...{ index }}
                      isView={isView}
                      type="text"
                      value={item.desc_non_conformity}
                      name="desc_non_conformity"
                      handleChange={(e, index) => handleChangeInput(e, index)}
                    />
                  </td>
                  <td>
                    {isView ? (
                      item.reason
                    ) : (
                      <FormControl
                        style={{
                          width: "250px",
                          border: "none",
                        }}
                        fullWidth={true}
                        variant="filled"
                        classes={{
                          root: classes.root,
                        }}
                      >
                        <InputLabel>Select Reason</InputLabel>
                        <Select
                          name="reason"
                          defaultValue={item.reason || ""}
                          classes={{
                            // underline: classes.underline,
                            root: classes.root,
                            select: classes.select,
                          }}
                          style={{ fontSize: "0.8rem" }}
                          disableUnderline
                          onChange={(e) => selectFailure(e, index)}
                        >
                          {failures[index].map((data, PIndex) => (
                            <MenuItem
                              className="option"
                              style={{ fontSize: "0.8rem" }}
                              key={PIndex}
                              value={`${data.potential_mode} , ${data.potential_cause[0]}`}
                            >
                              {data.potential_mode} , {data.potential_cause[0]}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                  </td>
                  <td
                    align="center"
                    style={{
                      border: "1px solid black",
                    }}
                  >
                    <TableReadEditCell
                      {...{ index }}
                      isView={isView}
                      type="number"
                      name="debit_note_num"
                      value={item.debit_note_num}
                      handleChange={(e, index) => handleChangeInput(e, index)}
                    />
                  </td>
                  <td
                    align="center"
                    style={{
                      border: "1px solid black",
                    }}
                  >
                    <TableReadEditCell
                      {...{ index }}
                      isView={isView}
                      type="text"
                      name="rate_pcs"
                      value={item.rate_pcs}
                      handleChange={(e, index) => handleChangeInput(e, index)}
                    />
                  </td>
                  <td
                    align="center"
                    style={{
                      border: "1px solid black",
                    }}
                  >
                    <TableReadEditCell
                      {...{ index }}
                      isView={isView}
                      type="number"
                      name="amount"
                      value={item.amount}
                      handleChange={(e, index) => handleChangeInput(e, index)}
                    />
                  </td>
                  <td
                    align="center"
                    style={{
                      border: "1px solid black",
                    }}
                  >
                    <TableReadEditCell
                      {...{ index }}
                      isView={isView}
                      type="number"
                      name="total_weight"
                      value={item.total_weight}
                      handleChange={(e, index) => handleChangeInput(e, index)}
                    />
                  </td>
                  <td
                    align="center"
                    style={{
                      border: "1px solid black",
                    }}
                  >
                    <TableReadEditCell
                      {...{ index }}
                      isView={isView}
                      type="text"
                      name="remarks"
                      value={item.remarks}
                      handleChange={(e, index) => handleChangeInput(e, index)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </TableContainerStyled>
      </div>
      <Modal
        openPopup={isSelectPartModal}
        title="Select PART"
        closeModal={(e) => selectSelectPartModal(false)}
      >
        <SelectPart
          {...{ handlePartDetails, resetPartDetails }}
          processes={scrapNoteData.processes[indexSelectPart.current]}
        />
      </Modal>
      <DialogSave isSubmitContent={true} />
      <DialogClose isSubmitContent={false} />
      <DialogUpdate isSubmitContent={false} />
    </section>
  );
};

export default ScrapAddEdit;
